/* eslint-disable camelcase */
import Session from "nexia_mobile/models/session";
import MediaType from "nexia_mobile/framework/media_type";
import CommercialLocationFixture from "nexia_mobile/models/fixtures/commercial_location";

$.mockjaxSettings.responseTime = 500;
$.mockjaxSettings.contentType = "application/json";
$.mockjaxSettings.logging = false;
$.mockjaxSettings.retainAjaxCalls = false;

export default class CommercialDemoSession extends Session {
  initialize() {
    this.setUrl("mobile/session");
    this._stubAllEndpoints();
  }

  destroy() {
    this._unstubAllEndpoints();
  }

  _unstubAllEndpoints() {
    this._handlerIds.forEach((id) => $.mockjax.clear(id));
    this._handlerIds = [];
  }

  _stubAllEndpoints() {
    this._handlerIds = [];

    const stub = (obj) => {
      this._handlerIds.push($.mockjax(obj));
    };

    function apiResponse(data) {
      return JSON.stringify({
        success: true,
        error: null,
        result: data,
      });
    }

    const location = _.extend({}, CommercialLocationFixture);
    location._links.self = { href: "mobile/houses/1" };

    const session = {
      _links: {
        child: [
          {
            href: "mobile/houses/1",
            type: MediaType.LOCATION,
            data: { id: location.id, name: location.name },
          },
        ],
      },
    };

    stub({
      url: /session/,
      responseText: apiResponse(session),
    });

    stub({
      url: /houses\/1/,
      responseText: apiResponse(location),
    });

    stub({
      url: /mode.*activate/,
      type: "POST",
      responseText: apiResponse({}),
    });

    stub({
      url: /automations/,
      responseText: apiResponse(location._urlMap.automations),
    });

    stub({
      url: /events/,
      response(request) {
        let date = new Date();
        let today = `${date.getFullYear()}-${date
          .getMonth()
          .toString()
          .padStart(2, "0")}-${date
          .getDate()
          .toString()
          .padStart(2, "0")}`;
        let yesterday = `${date.getFullYear()}-${date
          .getMonth()
          .toString()
          .padStart(2, "0")}-${(date.getDate() - 1)
          .toString()
          .padStart(2, "0")}`;

        this.responseText = apiResponse({
          item_type: MediaType.EVENT,
          items: [
            {
              device_name: "Clearwater",
              description: "New temperature 72",
              occurred_at: `${today}T11:40:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Clearwater",
              description: "Set to System Idle",
              occurred_at: `${today}T11:40:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Clearwater",
              description: "Set to Fan Running",
              occurred_at: `${today}T11:32:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Clearwater",
              description: "Set to Cooling",
              occurred_at: `${today}T11:30:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Springfield",
              description:
                "Schedule mode status set to Following Schedule - Occupied",
              occurred_at: `${today}T09:45:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Springfield",
              description: "Heat setpoint set to 65",
              occurred_at: `${today}T09:41:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Springfield",
              description: "Cool setpoint set to 72",
              occurred_at: `${today}T09:34:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Springfield",
              description: "Set to Cooling",
              occurred_at: `${today}T09:19:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Offices",
              description: "Set to Cooling",
              occurred_at: `${today}T07:36:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Offices",
              description: "Set to System Idle",
              occurred_at: `${today}T07:29:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Offices",
              description: "Set to Cooling",
              occurred_at: `${today}T07:14:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Show_Room",
              description: "Set to Cooling",
              occurred_at: `${yesterday}T08:01:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Show_Room",
              description: "Set to System Idle",
              occurred_at: `${yesterday}T07:50:01-05:00`,
              user_name: "Device Event",
            },
            {
              device_name: "Show_Room",
              description: "Set to Fan Running",
              occurred_at: `${yesterday}T07:50:01-05:00`,
              user_name: "Device Event",
            },
          ],
          _links: {
            self: {
              href: request.url,
            },
            page: {
              data: {
                current_page: 1,
                page_count: 1,
              },
            },
          },
        });
      },
    });

    Object.keys(location._urlMap).forEach((url) => {
      stub({
        url,
        type: "GET",
        response(request) {
          const resource = location._urlMap[request.url];
          this.responseText = apiResponse(resource);
        },
      });
    });

    stub({
      url: /mobile\/runtime_history/,
      response() {
        this.responseText = apiResponse({
          type: "runtime_history",
          chart: {
            chart: {
              type: "column",
            },
            title: {
              text: "",
            },
            subtitle: {
              text: "Daily History",
            },
            colors: ["#9f2d26", "#184c8e"],
            series: [
              {
                name: "Heat",
                data: [null, null, null, null, null, null, null, null],
                stack: "heat",
                state: "heat",
              },
              {
                name: "Cool",
                data: [9, 9, 7, 8, 11, 11, 14, 2],
                stack: "cool",
                state: "cool",
              },
            ],
            xAxis: {
              categories: [
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
                "Monday",
                "Tuesday",
              ],
              labels: {
                rotation: -45,
              },
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              max: 24,
              tickInternval: 4,
              title: {
                text: "Runtime (Hours)",
              },
            },
            legend: {
              layout: "vertical",
              align: "center",
              floating: false,
              shadow: false,
              itemStyle: {
                fontSize: "1em",
              },
            },
            tooltip: {
              shared: true,
              borderColor: "#000000",
            },
            credits: {
              enabled: false,
            },
            plotOptions: {
              column: {
                stacking: "normal",
              },
              series: {
                shadow: false,
              },
            },
          },
          table: {
            headings: ["Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Mon", "Tue"],
            series: [
              {
                name: "Aux Heat",
                data: ["-", "-", "-", "-", "-", "-", "-", "-"],
                stack: "heat",
                state: "heat_aux",
              },
              {
                name: "Outdoor High Temp.",
                data: [91, 89, 92, 88, 90, 94, 95, 68],
                stack: null,
                state: "outdoor_high_temperature",
              },
              {
                name: "Outdoor Low Temp.",
                data: [61, 65, 61, 63, 62, 69, 70, 62],
                stack: null,
                state: "outdoor_low_temperature",
              },
              {
                name: "Avg Indoor Temp.",
                data: [71.2, 70.8, 72.4, 72.4, 72.9, 72.7, 72.1, 72],
                stack: null,
                state: "average_indoor_temperature",
              },
              {
                name: "Avg Indoor Humidity",
                data: [50, 47, 46, 45, 48, 45, 44, 40],
                stack: null,
                state: "average_indoor_humidity",
              },
              {
                name: "Fan Only Runtime",
                data: [7.8, 5.9, 0.4, 0.3, 0.2, 0.5, 0.4, 0.3],
                stack: null,
                state: "fan_only",
              },
              {
                name: "Vent",
                data: [],
                stack: null,
                state: "vent",
              },
            ],
          },
          show_monthly_runtime_history: false,
        });
      },
    });

    stub({
      url: /thermostat_schedules.*\/(get_active_schedule)/,
      type: "POST",
      response() {
        let schedule = {
          temperature_scale: "f",
          days: [
            {
              name: "Mon",
              periods: [
                { name: "Unoccupied", time: 0, value: { cool: 82, heat: 62 } },
                {
                  name: "Occupied",
                  time: 7.5 * 60,
                  value: { cool: 78, heat: 70 },
                },
                {
                  name: "Unoccupied",
                  time: 16.5 * 60,
                  value: { cool: 82, heat: 62 },
                },
              ],
            },
            {
              name: "Tue",
              periods: [
                { name: "Unoccupied", time: 0, value: { cool: 82, heat: 62 } },
                {
                  name: "Occupied",
                  time: 7.5 * 60,
                  value: { cool: 78, heat: 70 },
                },
                {
                  name: "Unoccupied",
                  time: 16.5 * 60,
                  value: { cool: 82, heat: 62 },
                },
              ],
            },
            {
              name: "Wed",
              periods: [
                { name: "Unoccupied", time: 0, value: { cool: 82, heat: 62 } },
                {
                  name: "Occupied",
                  time: 7.5 * 60,
                  value: { cool: 78, heat: 70 },
                },
                {
                  name: "Unoccupied",
                  time: 16.5 * 60,
                  value: { cool: 82, heat: 62 },
                },
              ],
            },
            {
              name: "Thu",
              periods: [
                { name: "Unoccupied", time: 0, value: { cool: 82, heat: 62 } },
                {
                  name: "Occupied",
                  time: 7.5 * 60,
                  value: { cool: 78, heat: 70 },
                },
                {
                  name: "Unoccupied",
                  time: 16.5 * 60,
                  value: { cool: 82, heat: 62 },
                },
              ],
            },
            {
              name: "Fri",
              periods: [
                { name: "Unoccupied", time: 0, value: { cool: 82, heat: 62 } },
                {
                  name: "Occupied",
                  time: 7.5 * 60,
                  value: { cool: 78, heat: 70 },
                },
                {
                  name: "Unoccupied",
                  time: 16.5 * 60,
                  value: { cool: 82, heat: 62 },
                },
              ],
            },
            {
              name: "Sat",
              periods: [
                { name: "Unoccupied", time: 0, value: { cool: 82, heat: 62 } },
                {
                  name: "Occupied",
                  time: 7.5 * 60,
                  value: { cool: 78, heat: 70 },
                },
                {
                  name: "Unoccupied",
                  time: 12.5 * 60,
                  value: { cool: 82, heat: 62 },
                },
              ],
            },
            {
              name: "Sun",
              periods: [
                { name: "Unoccupied", time: 0, value: { cool: 82, heat: 62 } },
                {
                  name: "Occupied",
                  time: 7.5 * 60,
                  value: { cool: 78, heat: 70 },
                },
                {
                  name: "Unoccupied",
                  time: 12.5 * 60,
                  value: { cool: 82, heat: 62 },
                },
              ],
            },
          ],
        };
        this.responseText = apiResponse(schedule);
      },
    });

    stub({
      url: /schedules.*/,
      type: "GET",
      response() {
        let schedules = [
          {
            name: "7 Day Store Hours",
            temperature_scale: "f",
            days: [
              {
                name: "Mon",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Tue",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Wed",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Thu",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Fri",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Sat",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 12.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Sun",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 12.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
            ],
            _links: { self: { href: "mobile/schedules/1?house_id=1" } },
          },
          {
            name: "Weekday Only",
            temperature_scale: "f",
            days: [
              {
                name: "Mon",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Tue",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Wed",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Thu",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Fri",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Sat",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Sun",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
            ],
            _links: { self: { href: "mobile/schedules/2?house_id=1" } },
          },
          {
            name: "Monday Closed",
            temperature_scale: "f",
            days: [
              {
                name: "Mon",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Tue",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Wed",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Thu",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Fri",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                  {
                    name: "Occupied",
                    time: 7.5 * 60,
                    value: { cool: 78, heat: 70 },
                  },
                  {
                    name: "Unoccupied",
                    time: 16.5 * 60,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Sat",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
              {
                name: "Sun",
                periods: [
                  {
                    name: "Unoccupied",
                    time: 0,
                    value: { cool: 82, heat: 62 },
                  },
                ],
              },
            ],
            _links: { self: { href: "mobile/schedules/3?house_id=1" } },
          },
        ];

        this.responseText = apiResponse(schedules);
      },
    });

    stub({
      url: /.*/,
      type: "PUT",
      response(request) {
        const resource = location._urlMap[request.url];
        if (typeof request.data !== "string") {
          request.data = JSON.stringify(request.data);
        }
        const data = _.extend(resource, JSON.parse(request.data || "{}"));
        this.responseText = apiResponse(data);
      },
    });

    stub({
      url: /.*/,
      type: "POST",
      response(request) {
        if (typeof request.data !== "string") {
          request.data = JSON.stringify(request.data);
        }
        this.responseText = apiResponse(JSON.parse(request.data || "{}"));
      },
    });
  }

  _loadFromCache() {
    // no-op parent behavior
  }

  _addToSessionCache() {
    // no-op parent behavior
  }

  _defaultLocationId() {
    return 1;
  }
}



// WEBPACK FOOTER //
// ./src/models/commercial_demo_session.js